const covers = {
  "Concerts": require('./Concerts.jpg'),
  "Fairs": require('./Fairs.jpg'),
  "Festivals": require('./Festivals.jpg'),
  "Business meetings": require('./Business_Meetings.jpg'),
  "Exhibitions": require('./Exhibitions.jpg'),
  "Congresses": require('./Congresses.jpg'),
  "Conventions": require('./Conventions.jpg'),
  "Workshops": require('./Workshops.jpg'),
  "Sports": require('./Sports.jpg'),
  "Birthday celebration": require('./Birthday_Celebration.jpg'),
  "Weddings celebration": require('./Wedding_Celebration.jpg'),
  "Religious celebration": require('./Religious_Celebration.jpg'),
  "Parties": require('./Parties.jpg'),
  "Plays": require('./Plays.jpg'),
  "Fashion shows": require('./Fashion_Shows.jpg'),
  "Infantiles": require('./Infantiles.jpg'),
  "Seminars": require('./Seminars.jpg'),
  "Conferences": require('./Conferences.jpg'),
  "Congresses": require('./Congresses.jpg'),
  "Talks": require('./Talks.jpg'),
  "Online games": require('./Online_Games.jpg'),
  // "Streaming sessions": require('./Streaming_Sessions.jpg'),
  // "Video transmissions": require('./Video_Transmissions.jpg'),
  "Online workshops": require('./Online_Workshops.jpg'),
  "Online courses": require('./Online_Courses.jpg'),
  "Art samples": require('./Art_Samples.jpg'),
}

export default covers